__webpack_require__.p = "/sa/prdi-recommendations-fe/";